import React, { Component } from "react";
import DayPicker, { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";
//http://react-day-picker.js.org/
import Icon from 'material/graphic/icon/icon';


import injectSheet from "react-jss";
import styles from 'material/datepicker/datepicker_styles';
// disabled days is an array of days, can include an object that holds a date range
//[
//                     new Date(2017, 3, 12),
//                     new Date(2017, 3, 2),
//                      {
//                     after: new Date(2019, 1, 20),
//                     before: new Date(2019, 1, 25),
//                     }
//                     ]

class DatePicker extends Component {

    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleResetClick = this.handleResetClick.bind(this);
        this.NavBar = this.NavBar.bind(this)
        this.state = this.getInitialState();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps.range) !== JSON.stringify(this.props.range)) {
            this.setState({from: this.props.range.from, to: this.props.range.to})
        }
    }

    getInitialState() {
        return this.props.type === 'day' ? {selectedDay: null} : this.props.range;
    }
    handleDayClick(day, modifiers = {}) {
        //the modifiers object holds data on the click event like disabled,selected, etc..
        if (modifiers.disabled) return null;
        if(this.props.type === 'day'){
            this.props.handleRangeSelect(day);
            this.setState({
                selectedDay: modifiers.selected ? undefined : day,
            });
        } else {
            const range = DateUtils.addDayToRange(day, this.state);
            if(range.to === null || range.from === null) return null;
            if (this.state.from !== "" && this.state.to !== ""){
                this.setState({from: day, to: ""})
            } else {
                this.setState(range);
                this.props.handleRangeSelect(range);
            }
        }

    }
    handleResetClick() {
        this.setState(this.getInitialState());
    }

    NavBar({
               nextMonth,
               previousMonth,
               onPreviousClick,
               onNextClick,
               className
           }){
        return (
            <div className={className}>
                <div className={`previousMonth`} onClick={() => onPreviousClick()}><Icon name={`chevron-circle-left`} /></div>
                <div className={`nextMonth`} onClick={() => onNextClick()}><Icon name={`chevron-circle-right`}/></div>
            </div>
        );

    }



    render() {
        const { from, to } = this.state;
        const modifiers = { start: from, end: to };
        return (
            <div className={`datepicker ${this.props.classes.datepicker}`}>
                <DayPicker
                    className="Selectable"
                    selectedDays={this.props.type === 'day' ? this.props.selectedDay : [from, { from, to }]}
                    modifiers={modifiers}
                    onDayClick={this.handleDayClick}
                    numberOfMonths={this.props.numberOfMonths}
                    navbarElement={this.NavBar}
                    disabledDays={this.props.disabledDays}
                    fixedWeeks={true}
                />
            </div>
        );
    }
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(DatePicker);